import { useNotifier } from '@cbgms/base/notifier'
import { useTranslation } from 'react-i18next'

type GetQuantity = (currentValue: number, isOpEqualOpPromotionType: boolean, totalStock?: number) => number

const useQuantityExceedsMaxStockWarningMessage = () => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const getQuantityPostQuantityExceedsMaxStockValidation: GetQuantity = (currentValue, isOpEqualOpPromotionType, totalStock) => {
    if (isOpEqualOpPromotionType && totalStock && currentValue > totalStock) {
      notifier.warning(
        t('order.max-quantity-reached.toaster.title2'),
        `${t('order.max-quantity-reached.toaster.message2')} (${totalStock}).`
      )
      return totalStock
    }
    return currentValue
  }

  return getQuantityPostQuantityExceedsMaxStockValidation
}

export default useQuantityExceedsMaxStockWarningMessage
